import { render, staticRenderFns } from "./ArticleCommentItem.vue?vue&type=template&id=04af02b1&"
import script from "./ArticleCommentItem.vue?vue&type=script&lang=js&"
export * from "./ArticleCommentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports